import get from 'lodash/get';
import isObject from 'lodash/isObject';
import pick from 'lodash/pick';
import set from 'lodash/set';
import type { Event } from '@sentry/types';

// GraphQL error messages and other extensions can contain customer data
const SAFE_ERROR_PATHS = [
	'path',
	'extensions.statusCode',
	'extensions.errorType',
	'extensions.classification',
];

const toSafeGraphQLError = (error: unknown): string =>
	JSON.stringify(isObject(error) ? pick(error, SAFE_ERROR_PATHS) : {});

// `ExtraErrorData` truncates `source.errors` to `[Object]`, and Sentry does not normalise again
// after `beforeSend`, so rebuild them here from the original exception.
export const sanitiseGraphQLErrors = (event: Event, exception: Error): Event => {
	const errors: unknown = get(exception, 'source.errors');
	if (
		exception.name !== 'RelayNetwork' ||
		!Array.isArray(errors) ||
		!isObject(event.contexts?.RelayNetwork?.source)
	) {
		return event;
	}

	try {
		set(event, 'contexts.RelayNetwork.source.errors', errors.map(toSafeGraphQLError));
	} catch {
		// Leave the truncated errors rather than drop the event
	}
	return event;
};
